module.exports = __webpack_public_path__ + "assets/img/document-gray.12a0fb14.svg";